module.exports = __webpack_public_path__ + "./images/2972dd162180b6352dd98af01b6bd49d.webp";